import { render, staticRenderFns } from "./inPurchaseTransfer.vue?vue&type=template&id=106dfeeb&scoped=true"
import script from "./inPurchaseTransfer.vue?vue&type=script&lang=js"
export * from "./inPurchaseTransfer.vue?vue&type=script&lang=js"
import style0 from "./inPurchaseTransfer.vue?vue&type=style&index=0&id=106dfeeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106dfeeb",
  null
  
)

export default component.exports